export const state = {
  snackbar: false,
  title: "Title",
  text: "text",
  color: "secondary",
  timeout: 3000,
  multiLine: true,
  link: null,
  readonly_message_shown: false
};

export const mutations = {
  SET_SNACKBAR(state, data) {
    state.snackbar = true;
    state.title = data.title;
    state.text = data.text;
    state.color = data.color;
    // Optional navigation link: { label, route } (route is a router name).
    // Give the user extra time to click it.
    state.link = data.link || null;
    state.timeout = data.link ? 6000 : 3000;
  },
  SET_READONLY_MESSAGE_SHOWN(state, value) {
    state.readonly_message_shown = value;
  }
};

export const actions = {
  setSnackbar({ commit, state }, data) {
    // If a readonly message was just shown and this is an error message, skip it
    if (state.readonly_message_shown && data.color === "error") {
      return;
    }
    commit("SET_SNACKBAR", data);
  },
  setReadonlyMessageShown({ commit }, value) {
    commit("SET_READONLY_MESSAGE_SHOWN", value);
    // Auto-clear the flag after a short delay to allow normal messages again
    if (value) {
      setTimeout(() => {
        commit("SET_READONLY_MESSAGE_SHOWN", false);
      }, 1000);
    }
  }
};
